import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColor, ButtonSize } from '@predictiveindex/tapestry';
import { IconSize, IconType, ModuleName } from '../../core-data-model';
import { SiteNavigationService } from '../../core-services';
import { ModuleAccessService } from '../../system-services';
import { TranslationService } from '../../translations';
import { UpgradeAccountService } from './upgrade-account.service';
@Component({
    selector: 'upgrade-account',
    template: `
        @if (showNavigationUpgradeButton) {
            <tapestry-button
                id="upgradeButton"
                trackingName="upgrade-account-button-global"
                [text]="TR.key('upgradeButton.plans.pricing.text')"
                [size]="ButtonSize.Small"
                [icon]="'chat_bubbles'"
                [color]="ButtonColor.Outline"
                (buttonClicked)="upgradeAccount()"
                piTesting="upgrade-account-button"
            ></tapestry-button>
        } @else {
            @if (enableUpgradeButton) {
                <button
                    id="upgradeButton"
                    data-tracking="upgrade-account-button"
                    [ngClass]="getButtonClass()"
                    (click)="upgradeAccount()"
                    [disabled]="disabled"
                    piTesting="upgrade-account-button"
                >
                    @if (showUpgradeButtonIcon) {
                        <abstract-icon
                            class="upgrade-button-icon"
                            [iconType]="IconType.ConversationChat"
                            [iconSize]="IconSize.Medium"
                        >
                        </abstract-icon>
                    }
                    {{ getButtonText() }}
                </button>
            }
        }
    `,
    styleUrls: ['./upgrade-account.less'],
    standalone: false
})
export class UpgradeAccountComponent {
    @Input()
    buttonTextKeyName: string;

    @Input()
    requestFromPaywall = false;


    @Input()
    showUpgradeButtonIcon: boolean;

    @Output()
    onUpgradeAccountClick: EventEmitter<any> = new EventEmitter();

    @Output()
    buttonClicked = new EventEmitter();

    IconSize = IconSize;
    IconType = IconType;
    ButtonSize = ButtonSize;
    ButtonColor = ButtonColor;

    constructor(
        public TR: TranslationService,
        private upgradeAccountService: UpgradeAccountService,
        private moduleAccess: ModuleAccessService,
        private siteNavigation: SiteNavigationService
    ) {}

    get disabled() {
        return this.upgradeAccountService.upgradeButtonDisabled;
    }

    get enableUpgradeButton() {
        return true;
    }

    get showNavigationUpgradeButton() {
        return !this.requestFromPaywall;
    }

    getButtonClass(): string {
        const cssClass = this.requestFromPaywall
            ? 'button button-primary button-md paywall-btn'
            : 'button button-secondary button-sm header-btn';

        return cssClass;
    }

    getButtonText(): string {
        return !this.buttonTextKeyName
            ? this.TR.key('upgradeButton.name')
            : this.TR.key(this.buttonTextKeyName);
    }

    isPaidAccount() {
        if (this.siteNavigation.isInHire) {
            return this.moduleAccess.isPaidAccount(ModuleName.HireHero);
        }
    }

    async upgradeAccount() {
        await this.upgradeAccountService.upgradeAccount(
            this.requestFromPaywall
        );
    }
}
